export default "__VITE_ASSET__DIS3HK2P__"